import DataErrorBoundary from './DataErrorBoundary'
export default DataErrorBoundary



// WEBPACK FOOTER //
// ./src/atoms/DataErrorBoundary/index.js